var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu"},_vm._l((_vm.links),function(link){return _c('li',{key:link.url,staticClass:"menu__item"},[_c('MenuItem',{attrs:{"link":link}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }